module.exports = __webpack_public_path__ + "assets/images/0465ec693a252643f70595cb1ce914b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/colby-website/colby-website-0.jpg
// module id = 816
// module chunks = 0